import React from "react";
import Container from "./ui/Container";
import Logo from "./ui/Logo";
import { Mail, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200">
      <Container>
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="mb-6">
                <a href="/" className="inline-block">
                  <Logo size="md" />
                </a>
              </div>
              
              <p className="text-gray-600 mb-6">
                Innovative tech solutions that save time, reduce costs, and help your business thrive in the digital age.
              </p>
              
              <div className="flex">
                <a 
                  href="https://www.instagram.com/techovation.io" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-tech-blue hover:text-white transition-all duration-300"
                >
                  <Instagram size={18} />
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">Our Services</h3>
              <ul className="space-y-4">
                {[
                  "Custom Web Development",
                  "E-commerce Solutions",
                  "Salesforce Integrations",
                  "AI-Powered Workflows",
                  "Business Process Automation"
                ].map((service, index) => (
                  <li key={index}>
                    <a 
                      href="#" 
                      className="text-gray-600 hover:text-tech-blue flex items-center transition-colors duration-300"
                    >
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">Quick Links</h3>
              <ul className="space-y-4">
                {[
                  {name: "About Us", href: "#about"},
                  {name: "Our Services", href: "#services"},
                  {name: "Our Work", href: "#work"},
                  {name: "Contact Us", href: "#contact"},
                  {name: "Privacy Policy", href: "#"}
                ].map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href} 
                      className="text-gray-600 hover:text-tech-blue flex items-center transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">Contact Us</h3>
              <ul className="space-y-4">
                <li>
                  <a href="mailto:techovationio@gmail.com" className="text-gray-600 hover:text-tech-blue flex items-start transition-colors duration-300">
                    <Mail size={18} className="mr-3 mt-1 flex-shrink-0" />
                    <span>techovationio@gmail.com</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="https://www.instagram.com/techovation.io" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-600 hover:text-tech-blue flex items-start transition-colors duration-300"
                  >
                    <Instagram size={18} className="mr-3 mt-1 flex-shrink-0" />
                    <span>@techovation.io</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 py-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 mb-4 md:mb-0">
            © {currentYear} TechOvation.io. All rights reserved.
          </p>
          
          <div className="flex space-x-6">
            <a href="#" className="text-gray-600 hover:text-tech-blue text-sm transition-colors duration-300">
              Terms of Service
            </a>
            <a href="#" className="text-gray-600 hover:text-tech-blue text-sm transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-600 hover:text-tech-blue text-sm transition-colors duration-300">
              Cookie Policy
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
